import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.8mm"
    height={25.702}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 350303 350313"
    {...props}
  >
    <path
      d="M328409 229892H21894V21894h306515v207998zM331155 0H19158C8593 0 0 9201 0 20529v210723c0 11338 8593 20533 19158 20533h311997c10566 0 19148-9195 19148-20533V20529C350303 9195 341721 5 331155 0zm-79364 328419h-21905c-12075 0-21888-9813-21888-21899v-32841h-65677v32841c0 12086-9814 21899-21904 21899H98528c-6063 0-10957 4899-10957 10947 0 6053 4888 10947 10957 10947l153263-5c6047 0 10947-4889 10947-10942 0-6048-4900-10947-10947-10947z"
      style={{
        fill: "#292525",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
